<template>
  <div>
    <div
      class="modal-header"
      :class="{ 'text-center': step === '1', 'is-back-btn': showBackButton }"
    >
      <!-- step 1 -->
      <h5 v-show="step === '1'" class="event-title-header">{{ conference.name }}</h5>
      <p v-if="step === '1' && conference.id === 3908" style="margin-top: 10px;">
        <a
          href="https://sccap53.org/membership/join-sccap-renew-membership/"
          style="text-decoration: underline; color:  #3b64ad;"
        >Save money by registering to be a SCCAP member!</a> Dues are a low $40 a year.
      </p>
      <p v-show="step === '1' && conference.id !== 3908" class="event-date-header">{{ conference.date }}</p>

      <!-- button back (show for step: '1.1', '2', '2.1', '3') -->
      <div v-show="showBackButton" class="back-button-wrapper">
        <button
          type="button"
          class="btn btn-default modal-btn-back"
          :disabled="showIndicator"
          @click="goToPreviousStep()"
        >
          <!-- TODO: change to event-icon -->
          <i class="fa-regular fa-arrow-left left-icon"></i>
        </button>
      </div>

      <!-- title (show for step: '1.1', '2', '2.1', '3', '4') -->
      <div class="title-block">
        <h5 class="event-title-header">{{ title }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "step",
      "isFetching",
      "showIndicator"
    ]),

    showBackButton() {
      return this.step === '1.1' || this.step === '2' || this.step === '2.1' || this.step === '3';
    },

    title() {
      if (this.step === '1.1') {
        return 'Checkout';
      } else if (this.step === '2') {
        return this.conference.is_agenda_group ? 'Tickets' : 'Checkout';
      } else if (this.step === '2.1') {
        return 'Session Selection - Please Select The Sessions You Would Like To Attend From Each Group';
      } else if (this.step === '3') {
        return 'Checkout';
      } else if (this.step === '4') {
        return 'Success';
      }
    }
  },
  methods: {
    goToPreviousStep() {
      this.$store.dispatch('basketStore/changeStep', { type: "back" });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>